/*
 * vrteSystemts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrteSystemSetting: RouteRecordRaw = {
  path: '/esystem/setting',
  name: 'vrtesystemsetting',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'esystemcategorylist',
      name: 'vrteSystemCategoryList',
      component: () => import('./vpgeSystemCategoryList.vue'),
    },
    {
      path: 'esystemcategoryoperate',
      name: 'vrteSystemCategoryOperate',
      component: () => import('./vpgeSystemCategoryOperate.vue'),
    },
    {
      path: 'esystemmodulelist',
      name: 'vrteSystemModuleList',
      component: () => import('./vpgeSystemModuleList.vue'),
    },
    {
      path: 'esystemmoduleoperate',
      name: 'vrteSystemModuleOperate',
      component: () => import('./vpgeSystemModuleOperate.vue'),
    },
    {
      path: 'esystemoperationlist',
      name: 'vrteSystemOperationList',
      component: () => import('./vpgeSystemOperationList.vue'),
    },
    {
      path: 'esystemoperationoperate',
      name: 'vrteSystemOperationOperate',
      component: () => import('./vpgeSystemOperationOperate.vue'),
    },
    {
      path: 'esystemcsvspo2pgs',
      name: 'vrteSystemCsvSPO2PGS',
      component: () => import('./vpgeSystemCsvSPO2PGS.vue'),
    },
  ],
};
//
export default vrteSystemSetting;
//#end#
